<template>
    <ion-page id="main-content">
        <div class="fullScreenLoading" v-if="bigLoaderOpened">
            <div class="container">
                <div class="text">
                    <div v-html="bigLoaderText ? bigLoaderText : $t('pleaseWaitTheCollectionOfDataMayTakeTime')"></div>
                    <img src="../../../public/assets/images/cockpitLoader_PL.svg" v-if="systemVersion === 'pl'" />
                    <img src="../../../public/assets/images/cockpitLoader.svg" v-else />
                </div>
            </div>
        </div>
        <dh-header v-if="!hideHeader" :page-title="pageTitle" @show-ai-assistant="showAiAssistant" @show-feedback="showFeedback"></dh-header>
        <ai-assitant :openAIAssistant="openAIAssistant" @show-ai-assistant="showAiAssistant"></ai-assitant>
        <feedback :openFeedback="openFeedback" :page="feedbackPage" @show-feedback="showFeedback"></feedback>
        <ion-content class="background baseContent" scroll-y="true">
            <slot />
        </ion-content>
    </ion-page>
</template>

<script>
import {IonPage, IonContent} from '@ionic/vue';
import dhHeader from '../pageComponents/dhHeader.vue';
import { mapState } from 'vuex';
import {getSystemVersion} from "@/js/functions";
import {ref} from "vue";
import AiAssitant from "@/components/pageComponents/aiAssitant.vue";
import Feedback from "@/components/pageComponents/feedback.vue";

export default {
    props: ['pageTitle', 'pageDefaultBackLink', 'hideHeader', 'hideMenu'],
    components: {
        AiAssitant,
        Feedback,
        IonPage,
        IonContent,
        dhHeader,
    },
    data() {
        return {
            systemVersion: getSystemVersion(),
            openAIAssistant: ref(false),
            openFeedback: ref(false),
            feedbackPage: ref('')
        }
    },
    methods: {
        showAiAssistant(mode = null) {
            this.$nextTick(() => {
                if(mode == 'open') {
                    this.openAIAssistant = true;
                    return;
                }
                if(mode == 'close') {
                    this.openAIAssistant = false;
                    return;
                }
                this.openAIAssistant = !this.openAIAssistant;
            });
        },
        showFeedback(mode = null) {
            if (mode === 'close') {
                this.openFeedback = false;
                return;
            }

            if (mode === 'open' || (mode == null && !this.openFeedback)) {
                this.feedbackPage = this.getPageLabel(this.$route.path);
                this.openFeedback = true;
                return;
            }

            this.openFeedback = false;
        },
        getPageLabel(path) {
            // Localized name of the screen the feedback was sent from.
            // Ordered most-specific first; falls back to the raw path.
            const map = [
                ['/newContract', 'creatingContract'],
                ['/newBuyer', 'creatingBuyer'],
                ['/newShowing/sign', 'showingSignature'],
                ['/newShowing', 'registerShowing'],
                ['/reservations', 'reservations'],
                ['/priceChange', 'changePrice'],
                ['/propertiesSearch', 'propertySearch'],
                ['/dashboard', 'dashboard'],
                ['/leaderboard', 'leaderboard'],
                ['/duoCalculator', 'duoCalculator'],
                ['/systemMessages', 'systemMessages'],
                ['/drafts', 'savedDrafts'],
                ['/savedContracts', 'submittedContracts'],
                ['/changeIdentity', 'changeIdentity'],
                ['/loginRequests', 'loginRequests'],
                ['/notifications', 'notifications']
            ];
            const match = map.find(([prefix]) => path.startsWith(prefix));
            if (match) {
                return this.$t('feedback.pages.' + match[1]);
            }
            if (path === '/' || path === '') {
                return this.$t('feedback.pages.home');
            }
            return path;
        }
    },
    computed: {
        ...mapState(['bigLoaderOpened', 'bigLoaderText'])
    }
}
</script>